import { formatFullDateAndTimeWithLocalTimezone } from "~/utils/datetime";

export const getSyncedBy = (lastSyncAt: string | null, lastSyncUserName: string | null) => {
  let syncedBy = "";
  if (lastSyncAt) {
    syncedBy = formatFullDateAndTimeWithLocalTimezone(lastSyncAt, "MMM d, yyyy h:mm a", true);
  }
  if (lastSyncUserName) {
    syncedBy = `${syncedBy} by ${lastSyncUserName}`;
  }
  return syncedBy;
};
